module.exports = __webpack_public_path__ + "static/media/startLooper.dbc96108.png";


//////////////////
// WEBPACK FOOTER
// ./src/startLooper.png
// module id = 539
// module chunks = 0